module.exports = __webpack_public_path__ + "media/svg-new/avatar-24 1-b10d4d24.svg";